export default {
  PAGENOTFOUND: "Page not found.",
};
